import React, { useEffect, useState } from 'react';
import { GelBoxLayout, GelButton, GelCheckbox, GelCheckboxGroup, GelColumnLayout, GelContainerLite, GelEmailInput, GelForm, GelFormField, GelRowLayout, GelTextArea, GelTextInput } from '@tal-gel/components';
import { addressGroupPadding, boldLabel, requestPolicyForm, subSectionMinHeight, toastDiv, toastFail, toastSuccess, noTextDecoration, addressFieldPadding, firstAddressPadding } from '../Shared/Styles';
import PostRequestPolicyDetails from '../../services/PostRequestPolicyDetails';
import ToastMessage from '../../components/Shared/ToastMessage';
import { Link } from "react-router-dom";

const RequestPolicyDocuments = React.memo(({
    distributorClientNo,
    distributorNo,
    policyNumber,
    policyDetails,
    adviserAccountEmail,
    isStaff
}) => {
    const poEmail = policyDetails && policyDetails.policy ? policyDetails.policy.policyOwner.contactDetails.email : undefined;
    const [additionalDetails, setAdditionalDetails] = useState('');
    const [allClientPolicyDocuments, setAllClientPolicyDocuments] = useState(false);
    const [certificateOfCurrency, setCertificateOfCurrency] = useState(false);
    const [deliveryOption, setDeliveryOptions] = useState({
        adviserEmail: false,
        adviserPostal: false,
        clientEmail: false,
        clientPostal: false
    });
    const [deliveryAddress, setDeliveryAddress] = useState('');
    const [adviserEmail, setAdviserEmail] = useState('');
    const [clientEmail, setClientEmail] = useState('');
    const [adviserPostal, setAdviserPostal] = useState('');
    const [clientPostal, setClientPostal] = useState('');
    const [pds, setPDS] = useState(false);
    const [policyDocument, setPolicyDocument] = useState(false);
    const [renewalNotice, setRenewalNotice] = useState(false);
    const [sendAllDocs, setSendAll] = useState(false);
    const [taxDocuments, setTaxDocuments] = useState(false);
    const [failToastMessage, setfailToastMessage] = useState(false);
    const [successToastMessage, setSuccessToastMessage] = useState(false);
    const [count, setCount] = useState(0);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);

    const togglefailToastMessage = () => setfailToastMessage(!failToastMessage);
    const toggleSuccessToastMessage = () => setSuccessToastMessage(!successToastMessage);

    const queryString = window.location.search;

    useEffect(() => {
        if (count > 0) {
            sendAll();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [count]);

    const onCheckboxChange = ({ target: { id } }) => {
        if (id !== 'ALL' && sendAllDocs) {
            setSendAll(prevState => !prevState);
        }

        switch (id) {
            case 'CoC':
                setCertificateOfCurrency(prevState => !prevState);
                break;
            case 'TD':
                setTaxDocuments(prevState => !prevState);
                break;
            case 'PDS':
                setPDS(prevState => !prevState);
                break;
            case 'RN':
                setRenewalNotice(prevState => !prevState);
                break;
            case 'PD':
                setPolicyDocument(prevState => !prevState);
                break;
            case 'ACP':
                setAllClientPolicyDocuments(prevState => !prevState);
                break;
            case 'ALL':
                setSendAll(!sendAllDocs);
                setCount(count + 1);
                break;
            case 'adviserEmail':
                resetDelivery();
                setDeliveryOptions(prevState => ({
                    adviserEmail: !prevState.adviserEmail,
                    adviserPostal: false,
                    clientEmail: false,
                    clientPostal: false
                }));
                break;
            case 'adviserPostal':
                resetDelivery();
                setDeliveryOptions(prevState => ({
                    adviserEmail: false,
                    adviserPostal: !prevState.adviserPostal,
                    clientEmail: false,
                    clientPostal: false
                }));
                break;
            case 'clientEmail':
                resetDelivery();
                setDeliveryOptions(prevState => ({
                    adviserEmail: false,
                    adviserPostal: false,
                    clientEmail: !prevState.clientEmail,
                    clientPostal: false
                }));
                break;
            case 'clientPostal':
                resetDelivery();
                setDeliveryOptions(prevState => ({
                    adviserEmail: false,
                    adviserPostal: false,
                    clientEmail: false,
                    clientPostal: !prevState.clientPostal
                }));
                break;
            default:
        }
    }

    const resetForm = (event) => {
        setCertificateOfCurrency(false);
        setTaxDocuments(false);
        setPDS(false);
        setRenewalNotice(false);
        setPolicyDocument(false);
        setAllClientPolicyDocuments(false);
        setSendAll(false);
        setDeliveryOptions({
            adviserEmail: false,
            adviserPostal: false,
            clientEmail: false,
            clientPostal: false
        });
        setAdditionalDetails('');
        setDeliveryAddress('');
    }

    const sendAll = () => {
        setCertificateOfCurrency(sendAllDocs);
        setTaxDocuments(sendAllDocs);
        setPDS(sendAllDocs);
        setRenewalNotice(sendAllDocs);
        setPolicyDocument(sendAllDocs);
    }


    const resetDelivery = () => {
        setAdviserEmail('');
        setClientEmail('');
        setAdviserPostal('');
        setClientPostal('');
        setDeliveryAddress('');
    }

    const setDelivery = (event) => {
        if (deliveryOption.adviserEmail) {
            setAdviserEmail(event.target.value);
        }

        if (deliveryOption.clientEmail) {
            setClientEmail(event.target.value);
        }

        if (deliveryOption.adviserPostal) {
            setAdviserPostal(event.target.value);
        }

        if (deliveryOption.clientPostal) {
           setClientPostal(event.target.value);
        }

        setDeliveryAddress(event.target.value)
    }

    const setNotes = (event) => {
        setAdditionalDetails(event.target.value);
    }

    const UseDefaultAddress = () => {
        let address;
        const useAdviserEmail = !isStaff && deliveryOption.adviserEmail && adviserAccountEmail !== null;
        const usePolicyOwnerEmail = deliveryOption.clientEmail && poEmail && poEmail !== null;

        if (useAdviserEmail) {
            address = adviserAccountEmail;
        }

        if (usePolicyOwnerEmail) {
            address = poEmail;
        }

        return address;
    }

    async function submit() {
        let address = deliveryAddress;

        const deliveryMethod = Object.keys(deliveryOption).filter((key) => {
            return deliveryOption[key];
        });

        if (deliveryAddress.length === 0) {
            address = UseDefaultAddress();
        }

        const payload = {
            policyNumber: policyNumber,
            clientName: policyDetails.policy ? policyDetails.policy.policyOwner.owner : undefined,
            certificateOfCurrency: certificateOfCurrency ? certificateOfCurrency : undefined,
            taxDocuments: taxDocuments ? taxDocuments : undefined,
            pds: pds ? pds : undefined,
            renewalNotice: renewalNotice ? renewalNotice : undefined,
            policyDocument: policyDocument ? policyDocument : undefined,
            allClientPolicyDocuments: allClientPolicyDocuments ? allClientPolicyDocuments : undefined,
            additionalDetails: additionalDetails ? additionalDetails : undefined,
            deliveryMethod: deliveryMethod[0],
            address: address ? address : 'not provided.'
        };

        const result = await PostRequestPolicyDetails(payload);

            if (result) {
                setSuccessToastMessage(true);
                setShowSuccessMessage(true);
            }
            else {
                setfailToastMessage(true);
                resetForm();
            }
        }
    
    return (
        <GelContainerLite style={subSectionMinHeight}>
            {showSuccessMessage 
                ?<GelRowLayout gutter="large">
                        <div>
                            Your request was successfully submitted
                        </div>
    
                        <div>Please allow 3-5 business days to action email requests and 10 business days for post requests to be delivered.</div>           
                        
                        <Link to={`/dashboard/policy-details${queryString}`}>
                            <div>Click here to go back to the Policy Details.</div>
                        </Link>
                 </GelRowLayout>
                :<GelRowLayout gutter="large">
                    <div data-testid="RequestPolicyDocumentsLabel">Please select documents that you would like to request and your query will be forwarded to the appropriate business unit who will respond to you shortly.</div>

                    <GelForm
                        labelWidth={requestPolicyForm.formLabelWidth}
                        fieldGutter={requestPolicyForm.fieldGutter}
                        labelAtTop
                        disableOnSubmit
                        preventSubmitOnInvalid
                        onSubmit={submit}
                        onResponse={resetForm}
                    >
                    
                        <GelRowLayout gutter="large">
                            <GelColumnLayout distribution="1/2 1/2">
                                <GelFormField
                                    label="Documents Available for Request"
                                >
                                    <GelCheckboxGroup
                                        name="doc-selection"
                                        vertical
                                        gap="small"
                                        required min={1}
                                        requiredErrorMsg="At least one of the checkboxes must be checked"
                                    >
                                        <GelCheckbox
                                            data-testid="certificateOfCurrencyCheckbox"
                                            id="CoC"
                                            checked={certificateOfCurrency}
                                            onChange={onCheckboxChange}
                                            style={noTextDecoration}
                                        >
                                            Certificate of Currency
                                        </GelCheckbox>

                                        <GelCheckbox
                                            data-testid="taxDoumentsCheckbox"
                                            id="TD"
                                            checked={taxDocuments}
                                            onChange={onCheckboxChange}
                                        >
                                            Tax Documents
                                        </GelCheckbox>

                                        <GelCheckbox
                                            data-testid="pdsCheckbox"
                                            id="PDS"
                                            checked={pds}
                                            onChange={onCheckboxChange}
                                        >
                                            PDS
                                        </GelCheckbox>

                                        <GelCheckbox
                                            data-testid="renewalNoticeCheckbox"
                                            id="RN"
                                            checked={renewalNotice}
                                            onChange={onCheckboxChange}
                                        >
                                            Renewal Notice
                                        </GelCheckbox>

                                        <GelCheckbox
                                            data-testid="policyDocumentCheckbox"
                                            id="PD"
                                            checked={policyDocument}
                                            onChange={onCheckboxChange}
                                        >
                                            Policy Document
                                        </GelCheckbox>
                                        
                                        <GelCheckbox
                                            data-testid="sendAllCheckbox"
                                            id="ALL"
                                            checked={sendAllDocs}
                                            onChange={onCheckboxChange}
                                        >
                                            Send all Documents
                                        </GelCheckbox>
                                    </GelCheckboxGroup>
                                </GelFormField>

                                <GelFormField
                                    label="Policy Selection"
                                >
                                    <GelCheckboxGroup
                                        name="policy-selection"
                                        vertical
                                        gap="small"
                                        required min={1}
                                    >
                                        <GelCheckbox
                                            data-testid="sendDocumentsForPolicyCheckbox"
                                            id="SD"
                                            checked={true}
                                            onChange={onCheckboxChange}
                                            disabled={true}
                                        >
                                            Send Documents for policy {policyNumber}
                                        </GelCheckbox>

                                        <GelCheckbox
                                            data-testid="allClientPolicyCheckbox"
                                            id="ACP"
                                            checked={allClientPolicyDocuments}
                                            onChange={onCheckboxChange}
                                        >
                                            Send Documents for all client policies
                                        </GelCheckbox>  
                                    </GelCheckboxGroup>
                                </GelFormField>
                            </GelColumnLayout>

                            <GelColumnLayout distribution="1/2 1/2">
                                <GelFormField
                                    label="Delivery Method"
                                    width={'80%'}
                                >
                                    <GelCheckboxGroup
                                        name="delivery-method-checkbox-group"
                                        width={'100%'}
                                        vertical
                                        gap="small"
                                        required min={1}
                                        requiredErrorMsg="At least one of the checkboxes must be checked"
                                    >
                                        <GelCheckbox
                                            data-testid="adviserEmailCheckbox"
                                            id="adviserEmail"
                                            checked={deliveryOption.adviserEmail}
                                            onChange={onCheckboxChange}
                                        >
                                            Send to Adviser email address
                                        </GelCheckbox>

                                        <GelCheckbox
                                            data-testid="clientEmailCheckbox"
                                            id="clientEmail"
                                            checked={deliveryOption.clientEmail}
                                            onChange={onCheckboxChange}
                                        >
                                            Send to Policy Owner email address
                                        </GelCheckbox>

                                        <GelCheckbox
                                            data-testid="adviserPostalCheckbox"
                                            id="adviserPostal"
                                            checked={deliveryOption.adviserPostal}
                                            onChange={onCheckboxChange}
                                        >
                                            Send to Adviser postal address
                                        </GelCheckbox>

                                        <GelCheckbox
                                            id="clientPostal"
                                            data-testid="clientPostalCheckbox"
                                            checked={deliveryOption.clientPostal}
                                            onChange={onCheckboxChange}
                                        >
                                            Send to Policy Owner postal address
                                        </GelCheckbox>
                                    </GelCheckboxGroup>
                                </GelFormField>

                                <GelRowLayout>
                                    <div style={deliveryOption.adviserEmail ? addressGroupPadding : firstAddressPadding} className={ deliveryOption.adviserEmail ? 'visible' : 'invisible' }>
                                        { deliveryOption.adviserEmail && (
                                            <GelFormField label="">
                                                <GelEmailInput
                                                    data-testid="adviserEmailInput"
                                                    formatErrorMsg="Invalid email adress"
                                                    name="adviserEmailInput"
                                                    placeholder={adviserAccountEmail && isStaff ? "Please enter Adviser email address" : adviserAccountEmail}
                                                    onChange={setDelivery}
                                                    value={adviserEmail}
                                                    width="300px" />
                                            </GelFormField>
                                        )}
                                    </div>

                                    <div style={addressFieldPadding}>
                                        { deliveryOption.clientEmail && (
                                            <GelFormField label="">
                                                <GelEmailInput
                                                    data-testid="clientEmailInput"
                                                    formatErrorMsg="Invalid email adress"
                                                    placeholder={ poEmail ? poEmail : "Please enter Policy Owner email address"}
                                                    name="clientEmailInput"
                                                    onChange={setDelivery}
                                                    value={clientEmail}
                                                    width="300px" />
                                            </GelFormField>
                                        )}
                                    </div>

                                    <div style={addressFieldPadding}>
                                        { deliveryOption.adviserPostal && (
                                            <GelFormField label="">
                                                <GelTextInput
                                                    name="adviserPostalInput"
                                                    data-testid="adviserPostalInput"
                                                    placeholder="Please enter Adviser postal address"
                                                    onChange={setDelivery}
                                                    value={adviserPostal}
                                                    width="300px" />
                                            </GelFormField>
                                        )}
                                    </div>

                                    <div style={addressFieldPadding}>
                                        { deliveryOption.clientPostal && (
                                            <GelFormField label="">
                                                <GelTextInput
                                                    name="clientPostalTextInput"
                                                    data-testid="clientPostalTextInput"
                                                    placeholder="Please enter Policy Owner postal address"
                                                    onChange={setDelivery}
                                                    value={clientPostal}
                                                    width="300px" />
                                            </GelFormField>
                                        )}
                                    </div>
                                </GelRowLayout>
                            </GelColumnLayout>
                        </GelRowLayout>

                        <GelRowLayout style={{ paddingBottom: '40px' }}>
                            <div><span style={boldLabel}>NOTE: </span>If no address is provided the stored address will be used for the selected delivery method.</div>
                        </GelRowLayout>

                        <GelFormField
                            label="Add details to be sent with request"
                        >
                            <GelTextArea
                                name="additional-info-input"
                                data-testid="requestPolicyDocumentsAdditionDetails"
                                rows={4}
                                value={additionalDetails}
                                onChange={setNotes}
                            />
                        </GelFormField>

                        <div><span style={boldLabel}>NOTE: </span>Please allow 3-5 business days to action email requests and 10 business days for post requests to be delivered.</div>

                        <GelBoxLayout
                            space="auto"
                            distribution="end"
                        >
                            <GelButton
                                data-testid="requestPolicyDocumentsReset"
                                secondary
                                medium
                                onClick={resetForm}
                            >
                                Reset
                            </GelButton>

                            <GelFormField>
                                <GelButton
                                    name=""
                                    data-testid="requestPolicyDocumentsSubmit"
                                    primary
                                    medium
                                    submit
                                >
                                    Send
                                </GelButton>
                            </GelFormField>
                        </GelBoxLayout>
                    </GelForm>
                </GelRowLayout>    
            }

            <div style={toastDiv}>
                <ToastMessage
                    toggleToast={toggleSuccessToastMessage}
                    toastType={toastSuccess}
                    showToast={successToastMessage}
                    message={'Policy documents request has been successfully submitted.'} />

                <ToastMessage
                    toggleToast={togglefailToastMessage}
                    toastType={toastFail}
                    showToast={failToastMessage}
                    message={'Failed to submit policy documents request. Please try again.'} />
            </div>
        </GelContainerLite>
    )
});

export default RequestPolicyDocuments;